import React from "react";
import { Modal, Button, Card, Typography, notification } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import firebaseApp from "../Components/firebaseConfig";

const { Title } = Typography;
const auth = getAuth(firebaseApp);

const LoginPopup = ({ setUser, isOpen, onClose, onLogin, user }) => {
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      const userData = {
        userId: result.user.uid,
        name: result.user.displayName,
        email: result.user.email,
      };

      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);

      await fetch("https://backend-matihaat.onrender.com/auth/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });

      notification.success({ message: "Login Successful" });
      navigate("/");
    } catch (error) {
      console.error("Google login error:", error);
      notification.error({ message: "Google Login Failed", description: error.message });
    }
  };

  return (
    <Modal title="Login / Register" open={isOpen} onCancel={onClose} footer={null}>
      <Card bordered={false}>
        <Title level={4}>Login</Title>

        <Button
          icon={<GoogleOutlined />}
          onClick={handleGoogleLogin}
          block
        >
          Sign in with Google
        </Button>
      </Card>
    </Modal>
  );
};

export default LoginPopup;
